var render = function (_h,_vm) {var _c=_vm._c;return _c('svg',{class:['atom-loading-android', '' !== _vm.props.type && ("text-" + (_vm.props.type))],attrs:{"width":"36","height":"36","viewBox":"0 0 50 50"}},[_c('circle',{attrs:{"cx":"25","cy":"25","r":"20","fill":"none","stroke":"currentColor","stroke-width":"5","stroke-miterlimit":"10"}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0fd06b12","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{"stripWithFunctional":true}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/packages/Loading/Core/Android.vue
// module id = 295
// module chunks = 0